<template>
  <v-snackbar
    v-bind="$attrs"
    v-on="$listeners"
    color="#DCE1F3"
  >
    <div class="d-flex align-center">
      <v-icon :color="icon_color">{{ icon }}</v-icon>
      <span
        class="ml-4"
        :class="$style.messageText"
      >{{ message }}</span>
    </div>
  </v-snackbar>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Toast extends Vue {
  @Prop({ type: String, default: 'toast message' })
  message!: string;

  @Prop({ type: String, default: 'mdi-check-circle-outline' })
  icon!: string;

  @Prop({ type: String, default: '#2196F3' })
  icon_color!: string;
}

</script>

<style module lang="scss">
.messageText {
  font-size: 16px;
  color: #212121;
}
</style>
